module.exports = __webpack_public_path__ + "static/media/editSquare.0148b1ae.svg";